module.exports = __webpack_public_path__ + "static/media/references.a654ceff.jpg";